




















import { Component, Vue, Provide } from "vue-property-decorator";
import { ColumnsConfig } from "@/common/BaseConfig";
import { IHotLineItem } from "@/api/types.d";
import request from "@/api/index";
import { ActionSheet } from "vant";
import native from "@/common/Native";
interface Actions {
  name: string;
}
@Component({
  components: {
    ActionSheet
  }
})
export default class GovernmentHotline extends Vue {
  hotLineList: IHotLineItem[] = [];
  selectPhone: string = "";
  actions: Actions[] = [];
  showActions: boolean = false;

  mounted() {
    this.getHotLine();
  }
  getHotLine() {
    request.hotline().then(result => {
      this.hotLineList = result.data.dataList;
    });
  }

  hotLineClick(item: string) {
    this.actions = [];
    item
      .split(",")
      .filter(str => str != "")
      .forEach(str => {
        this.actions.push({
          name: str
        });
      });
    this.showActions = true;
  }
  onSelect({ name }: Actions) {
    native.call(name);
  }
}
